/* eslint-disable react/no-unescaped-entities */
import React, { useMemo } from 'react';
import { getLocale } from '../../i18n';
import '../PolicyAndServicePopup.global.styl';

function Service({ visible }: { visible: boolean }) {
  const enContent = useMemo(
    () => (
      <div className="policy-content">
        <h2>Terms of Use</h2>
        <div style={{ marginBottom: 24 }}>
          <i>Published February 26, 2021</i>
        </div>
        <p>
          Welcome to the
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.miotech.com"
            style={{ margin: '0 4px' }}
          >
            www.MioTech.com
          </a>
          website and other MioTech URLs and websites (collectively, the “
          <strong>Sites</strong>”) operated by MioTech. By visiting and using
          the Sites you will be accepting these Terms of Use ("
          <strong>TOU</strong>"). The TOU governs your access to and use of
          the Sites and any of the services we provide through the Sites
          (together the “<strong>Services</strong>”).
          <strong>
            Please read them carefully and if you disagree with the TOU in any
            way, then do not use the Sites or any of the Services
          </strong>
          . MioTech reserves the right to post changes to the TOU on the Sites
          at any time. If we make any material changes to this TOU, we will
          post the updated TOU here, along with its effective date, and notify
          you by email or by means of a notice on our Sites.
          <strong>
            If any TOU changes are not acceptable, you must stop your use of
            the Sites
          </strong>
          . In these TOU, "MioTech" and "we" refer to Mioying Financial
          Technology (HK) Limited and Yingtou Information Technology
          (Shanghai) Limited (颖投信息科技(上海)有限公司) and their
          affiliates, and "<strong>User</strong>" or "<strong>you</strong>"
          refer to each visitor to the Sites.
        </p>

        <p>
          If you subscribe to any Services offered through the Sites, you may
          also be subject to additional terms and conditions ("
          <strong>Terms of Service</strong>" or "<strong>TOS</strong>")
          applicable to such Services, which will be brought to your attention
          at that time.
        </p>

        <h3>Sites and Services</h3>

        <p>
          You must register as a member on the Sites in order to access and
          use some Services. Further, MioTech reserves the right, without
          prior notice, to restrict access to or use of certain Services (or
          any features within the Services) to paying Users, or subject to
          other conditions that MioTech may impose in our discretion.
        </p>

        <p>
          <strong>
            We do not guarantee that access to or use of the Sites or any
            Services will be uninterrupted or error free, and MioTech shall
            not be liable for any feature not being accessible or for any
            unavailability of its Site and Services
          </strong>
          . The Site and its features may be expanded, limited or modified at
          any time by MioTech to meet the needs of its Users, or for technical
          or other reasons, without advance notice or reason. We may also in
          our sole discretion, and at any time, discontinue providing,
          temporarily or permanently, any or all of the Sites or Services,
          without notice. Services (or any features within the Services) may
          vary for different regions and countries. No warranty or
          representation is given that a particular Service or feature or
          function thereof or the same type and extent of the Service or
          features and functions thereof will be available for Users. MioTech
          may in our sole discretion limit, deny or create different levels of
          access to and use of any Services (or any features within the
          Services) with respect to different Users.
        </p>

        <p>
          To access some of the content or features of the Sites or its
          Services, Users may need to enhance or update the hardware or
          software in their computer systems. MioTech assumes no
          responsibility for any failure to access the Sites or any Services,
          partially or fully, whether due to the User's system, the Internet
          network or any other cause.
        </p>

        <h3>Minors</h3>

        <p>
          These Services do not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from children
          under 13.
          <strong>
            You may not use the Sites if you are under 13 years of age
          </strong>
          . In the case we discover that a child under 13 has provided us with
          personal information, we immediately delete this from our servers.
          If you are a parent or guardian and you are aware that your child
          has provided us with personal information, please contact us so that
          we will be able to do necessary actions.
        </p>

        <h3>Compliance with Laws</h3>

        <p>
          <strong>
            You agree to comply with all applicable laws in connection with
            your purchasing and/or viewing of any content in the Sites or
            through the Services
          </strong>
          . Further, access to our Sites or Services from certain territories
          may be prohibited. You agree that you will not violate any
          applicable data export laws in connection with your purchase and/or
          viewing of the content in the Sites or through the Services.
        </p>

        <h3>No Individual Investment Advice</h3>

        <p>
          <strong>
            The Sites does not provide individual or customized legal, tax,
            accounting, or investment services. Since each individual's
            situation is unique, a qualified professional should be consulted
            before making financial decisions.
          </strong>
        </p>

        <h3>Site Content and Services Limitations</h3>

        <p>
          <strong>
            We make no guarantees as to the accuracy, thoroughness or quality
            of the information on the Sites or through the Services, which is
            provided only on an “AS-IS” and “AS AVAILABLE” basis at User’s
            sole risk. This information may be provided by third parties and
            MioTech shall not be responsible or liable for any errors,
            omissions or inaccuracies in the Site content. The information and
            investment, accounting, or legal analysis strategies provided at
            the Sites (if any) are neither comprehensive nor appropriate for
            every individual. Some of the information is relevant only in the
            PRC and Hong Kong, and may not be relevant to or compliant with
            the laws, regulations or other legal requirements of other
            countries. It is your responsibility to determine whether, how and
            to what extent your intended use of the information and Services
            will be technically and legally possible in the areas of the world
            where you intend to use them. You are advised to verify any
            information before using it for any personal, financial,
            accounting, legal, or business purpose. In addition, the opinions
            and views expressed on the Sites and through any of the Services
            do not reflect the opinions or suggestions of MioTech or its
            management. The Site content and Services may be modified at any
            time by us, without advance notice or reason, and MioTech shall
            have no obligation to notify you of any corrections or changes to
            any Site content and Services.
          </strong>
        </p>

        <h3>License to Use Site Content and Services</h3>

        <p>
          We grant you a limited personal use license to access and use the
          Sites content and Services solely for your own personal use,
          provided that the content is not modified and all proprietary
          notices are kept intact.
          <strong>
            You may not reproduce, publish, translate, merge, sell, rent,
            distribute the content, or create a derivative work of the content
            on any other website or as part of any educational, training or
            reference materials. You may not frame or utilize framing
            techniques to enclose any content on the Sites and from the
            Services.
          </strong>
        </p>

        <h3>Third Party Content</h3>

        <p>
          Any testimonials, opinions, advice, product or service offers, or
          other information or content made available on or through the Sites
          or Services by third parties (if any) (“
          <strong>Third Party Content</strong>”) are solely those of their
          respective providers and not of MioTech which does not guarantee the
          accuracy, completeness, reliability or usefulness of Third Party
          Content.
          <strong>
            It is the responsibility of the User to evaluate Third Party
            Content and MioTech shall not be liable for any damage or loss
            caused by Users’ reliance on or other use of Third Party Content
          </strong>
          .
        </p>

        <h3>MioTech Widgets</h3>

        <p>
          MioTech may, in its sole discretion, provide certain widgets subject
          to this TOU (the “<strong>Widgets</strong>”).
          <strong>
            By accessing and using any Widget (including copying any Widget
            html code), you agree to be bound by the following:
          </strong>
          <br />
          • You may only display the Widget(s) on a website you own and
          operate;
          <br />
          • You may not modify any Widget including without limitation that
          you may not change any code, obscure or disable any element of any
          Widget, tag links to MioTech with a “no follow” attribute or similar
          mechanism; <br />• You agree not to make any representations or
          warranties (express or implied) about MioTech or the Site; <br />•
          You may not suggest or imply any affiliation with, sponsorship, or
          endorsement by MioTech; <br />• You may not place the Widget on any
          site that contains any content that is in any way unlawful, harmful,
          obscene, harassing, or racially, ethnically, or otherwise
          objectionable. Additionally, you may not place the Widget on any
          site that infringes any MioTech intellectual property or other
          rights, or violates any applicable law; <br />• This TOU does not
          grant you any right in any MioTech code, content, logos or
          trademarks beyond the limited permission to display the Widget
          granted herein. <br />• MioTech reserves the right at any time to
          terminate or modify your permission to display the Widget. The
          Widgets are subject to change from time to time in our sole
          discretion. We may cease to return content from the Widget at any
          time in our sole discretion.
        </p>

        <h3>Account Creation</h3>

        <p>
          General. The Services offered by MioTech require you to create an
          account. When you create an account, you agree that you have the
          authority to create that account and that all information you
          provide will be true, accurate, current, and complete. You are
          solely responsible for keeping your login information (e.g., user ID
          and password) accurate, secure, and confidential. You are also
          responsible for any activity resulting from use of your login
          information. You agree to immediately inform us if you suspect that
          your login information has been comprised. We are not liable to you
          for any losses or damages you incur resulting from unauthorized use
          of your login information.
        </p>

        <p>
          Social Sign in. If you login or sign in using social networking
          functionality, e.g., Facebook, you agree to abide by the applicable
          social network’s terms and conditions.
        </p>

        <h3>Advanced Services – for Users</h3>

        <p>
          MioTech may offer certain Services, including, for example,
          MioTech’s AMI service or any trial services thereof (collectively,
          the “<strong>Advanced Services</strong>”), which allow Users to use
          MioTech’s AI-driven investing technologies to manage risks.
          <strong>
            Your use of and reliance on such services, if any, is entirely at
            your own risk, and you are solely responsible for complying with
            this TOU at all times
          </strong>
          .
        </p>

        <h3>IMPORTANT:</h3>

        <p>
          <strong>No Client Relationship; No Privilege.</strong>
          By using the Advanced Services,
          <strong>
            MioTech do not intend to form, and do not form an advisor-client,
            planner-client, or any other direct privileged or professional
            relationship with any User of the Sites
          </strong>
          . Additionally, none of the Third Party Content will be treated as
          private or confidential, nor is it protected by attorney-client, or
          any other privilege, and it may be read, collected, and used by
          MioTech and others.
        </p>

        <h3>PLEASE NOTE:</h3>
        <p>
          <strong>
            MioTech does not provide tax, accounting, legal, investment, or
            financial services. The information available through MioTech’s
            Advanced Service is solely for informational purposes at User’s
            sole risk. The information is not meant to be, and should not be
            construed as advice for investment, financial planning, legal,
            accounting, or tax purposes. The publication by MioTech of any
            information or analysis is not and shall not be deemed an
            endorsement or recommendation of any third party by MioTech.
            MioTech makes no guarantees as to the accurateness, quality, or
            completeness of the information and MioTech shall not be
            responsible or liable for any errors, omissions, inaccuracies in
            the information or for any User’s reliance on the information.
            User is solely responsible for verifying the information as being
            appropriate for user’s personal use, including without limitation,
            seeking the advice of a qualified professional regarding any
            specific financial, legal, accounting, or tax questions a user may
            have. MioTech is not endorsed by or affiliated with any
            state/provincial/territorial bar association or other legal or
            accounting membership organization or association, tax
            authorities, or agencies or associations, or the Financial
            Industry Regulatory Authority (FINRA) in the U.S., the Investment
            Industry Regulatory Organization of Canada (IIROC) or any other
            financial regulatory authority, agency, or association.
          </strong>
        </p>

        <p>
          <strong>
            You may not reproduce, upload, transmit, distribute, publicly
            display, sell, publish, copy, frame or utilize framing techniques
            to enclose or otherwise use the Advanced Services, and/or any
            content or materials provided therein for any commercial purpose
            without MioTech’s express written consent
          </strong>
          .
        </p>

        <h3>Viruses</h3>

        <p>
          <strong>
            MioTech does not guarantee that files available for downloading
            through its Site will be free of infection or viruses or other
            code that may have contaminating or destructive properties
          </strong>
          . You are responsible for implementing sufficient procedures and
          checkpoints to satisfy your particular requirements for integrity,
          security and accuracy of data input and output, and for maintaining
          a means external to the Site for the reconstruction of any lost
          data.
        </p>

        <h3>Advertisers Are Not Endorsed</h3>

        <p>
          Though we seek to partner with quality companies, we are not
          responsible for the claims or representations made by advertisers
          and sponsors (if any). MioTech does not review, endorse or recommend
          the products or services of any company mentioned on our Sites. We
          will not be liable in any way for damages of any kind resulting out
          of the misuse of any personal information or data submitted by you
          to an advertiser or sponsor.
        </p>

        <h3>Links</h3>

        <p>
          As a convenience to Users, the Sites and Services may provide links
          to other sites or resources. Because we do not review and have no
          control over such sites and resources, MioTech shall not be
          responsible or liable for use of or reliance on any content,
          products, services or information at such sites or resources.
          Inclusion of any links does not imply any endorsement, affiliation,
          approval, association or sponsorship by MioTech of the linked
          websites, resources, their operators or owners. When you select a
          link, you may be leaving our Site. The information available on
          third parties websites may have certain restrictions on its use or
          distribution which differ from this TOU.
        </p>

        <h3>Prohibited Conduct</h3>

        <p>
          <strong>The following activities are strictly prohibited:</strong>
          <br />• Using the Sites or Services for any unlawful or fraudulent
          purpose (including links); <br />• Posting materials containing
          viruses or other malicious or destructive code in the Sites; <br />•
          Engaging in any activities that are defamatory, violate the personal
          privacy rights of others, or infringe any person's rights;
          <br />
          • Using the Sites or Services for purposes that is unlawful,
          harmful, threatening, abusive, harassing, tortious, defamatory,
          vulgar, obscene, libelous, hateful, degrading to others on the basis
          of gender, race, class, ethnicity, national origin, religion, sexual
          preference, disability or other classification or otherwise
          objectionable in any way;
          <br />• Copying, modifying, creating a derivative work of, reverse
          engineer, reverse assemble or otherwise attempt to discover any
          source code of the Sites or Services;
          <br />• Removing or obscuring the copyright notice or other notices
          displayed in connection with the content accessible through the
          Sites or Services;
          <br />• Interfering with or disrupting the Sites functionalities,
          Services, or servers and networks connected to Site, or disobeying
          any requirements, procedures, policies, or regulations of networks
          connected directly or indirectly to the Site; <br />• Modifying the
          Sites or Services in any manner or form, or using modified versions
          of the Sites or Services, including (without limitation) for the
          purpose of obtaining unauthorized access to the Sites or Services;{' '}
          <br />• Reproducing, printing, caching, storing, framing or
          distributing content retrieved from the Sites or Services in any way
          not authorized by this TOU or for any commercial use without the
          prior written permission of MioTech;
          <br />• Selling, assigning, sublicensing, or otherwise transferring
          any right in the Services or content accessible through the Sites;
          <br />• Accessing the Sites or Services by any means other than
          through the interface that is provided by MioTech; <br />• Using the
          Sites or Services to violate any law (whether local,
          state/provincial/territorial, national, or international), whether
          or not intentionally; <br />• Impersonating any person or entity, or
          falsely stating or otherwise misrepresenting your affiliation with
          any person or entity; <br />• Engaging in "screen scraping,"
          "database scraping,"; and/or <br />• Facilitating violations of this
          TOU or the Privacy Policy.
        </p>

        <p>
          <strong>
            If any User breaches any terms of this TOU, or if MioTech has
            reasonable grounds to believe that a User is in breach of any
            terms of this TOU, including any User conducting any of the above
            prohibited activities, MioTech shall have the right to take such
            disciplinary actions as it deems appropriate, including without
            limitation: (i) suspending or terminating the User’s account and
            any and all accounts determined to be related to such account by
            MioTech in its sole discretion without liability for any losses or
            damages arising out of or in connection with such suspension or
            termination; (ii) restricting, downgrading, suspending or
            terminating the subscription of, access to, or current or future
            use of any Service; (iii) imposing other restrictions on the
            User’s use of any features or functions of any Service as MioTech
            may consider appropriate in its sole discretion; and (v) any other
            corrective actions, discipline or penalties as MioTech may deem
            necessary or appropriate in its sole discretion.
          </strong>
        </p>

        <h3>Privacy</h3>

        <p>
          <strong>
            The Sites may collect personal information from some Users
          </strong>
          . Please review our Privacy Policy to understand what information we
          collect and store, how that information is used, how we may share
          that information, and your rights in connection with your personal
          information. The Privacy Policy is incorporated by reference and
          made a part of this TOU.
        </p>

        <h3>Communications</h3>

        <p>
          When you visit our Sites, use any of our Services, or send us an
          email, you expressly indicate your consent to electronically receive
          any and all communications, notices, and our disclosures that we may
          provide in connection with your use of the Sites and/or Services,
          including, without limitation, e-mail, and in-website
          communications. All agreements, notices and communications that we
          provide to you by email will satisfy all legal requirements that
          they be in writing and delivered to you. MioTech will have the right
          to disclose any email sent by a User, or any objectionable material,
          to comply with legal process or to protect the rights or property of
          MioTech, its customers, suppliers and Users. Any such notices may
          also include emails with promotional, marketing, and advertising
          information and recommendations that we believe may be of interest
          to you, in accordance with applicable law. You may unsubscribe
          following the instructions on any email, excepting that we may still
          send you administrative and transactional notices, including,
          without limitation, information about your Account, confirmation of
          your purchase of Services, information about your progress, or other
          services that may be necessary to provide you with any one of the
          Services.
        </p>

        <p>
          If you provide your telephone number to us when you register for an
          Account or use other MioTech Services on the Sites, you expressly
          consent to receive autodialed or prerecorded calls and text messages
          from MioTech at that number. If a telephone number is a mobile
          telephone number, you hereby consent to receive SMS or text messages
          at that number. We may place such calls or texts to (i) notify you
          about your account and any use thereof; (ii) provide you with
          necessary services, etc.; (iii) troubleshoot problems with your
          account; (iv) resolve disputes; (v) contact you with offers and
          promotions; or (vi) as otherwise necessary to service your account
          or enforce these TOU, our policies, applicable law, or any other
          agreement we may have with you. We will not share your phone number
          with third parties for their purposes without your consent. We may
          share your phone numbers with our Affiliates or with our service
          providers, such as customer support, billing or collections
          companies, who we have contracted with to assist us in pursuing our
          rights or performing our obligations under these TOU, our policies,
          applicable law, or any other agreement we may have with you. You
          agree these parties may also contact you using autodialed or
          prerecorded calls and text messages, as authorized by us to carry
          out the purposes we have identified above, and not for their own
          purposes. Standard telephone minute and text charges may apply.
        </p>

        <p>
          <strong>
            You understand and consent that we may, in our discretion, monitor
            or record telephone conversations you or anyone acting on your
            behalf has with us or our agents for quality control and training
            purposes or for our own protection
          </strong>
          . You acknowledge and understand that, while your communications
          with us may be overheard, monitored, or recorded, not all telephone
          lines or calls may be recorded by us, and
          <strong>
            we do not guarantee that recordings of any particular telephone
            calls will be retained or retrievable
          </strong>
          .
        </p>

        <h3>Feedback</h3>

        <p>
          We welcome all feedback, ideas, inventions, materials, and
          suggestions (“Feedback”) from our Users regarding our Services.
          <strong>
            You understand and agree that MioTech does not waive any rights to
            use similar and/or related Feedback previously or
            contemporaneously known to it
          </strong>
          , whether developed by its employees, contractors, obtained from
          other sources, or submitted by other Users.
          <strong>
            Further, by submitting any Feedback, you grant us the right to use
            the Feedback without any restrictions on the use of such Feedback
            or any compensation to you
          </strong>
          .
        </p>
        <h3>Proprietary Rights</h3>

        <p>
          The MioTech Site and its content are protected by copyright,
          trademark and other proprietary laws.
        </p>
        <p>
          Any MioTech logos and/or trademarks that appear in any Site or
          Services are our property and may not be used without our express
          written consent. All other trademarks, service marks and logos used
          in connection with any Services, with or without attribution, are
          the trademarks, services, or logos of their respective owners and
          may not be used without their express written consent.
        </p>
        <p>
          Reporting Copyright Infringement. MioTech takes claims of copyright
          infringement seriously. We will respond to notices of alleged
          copyright infringement that comply with applicable law.
        </p>
        <p>
          Repeat Infringers. It is our policy in appropriate circumstances to
          disable access to the Sites and/or terminate the accounts of users
          who are repeat infringers of these TOU.
        </p>
        <h3>Subscription Services</h3>

        <p>
          Although MioTech offers services in many parts of the world, certain
          MioTech services may not be available in or suitable for certain
          countries or locales. We reserve the right to discontinue or to make
          changes to, our Site and any of our Services at any time without
          advance notice.
        </p>
        <h3>Limitation of Liability</h3>

        <p>
          <strong>
            DISCLAIMER OF WARRANTIES: THE SITES AND SERVICES ARE PROVIDED FOR
            INFORMATIONAL PURPOSES ONLY. NO CONTENT ON OUR SITEs IS INTENDED
            TO CONSTITUTE PROFESSIONAL ADVICE, WHETHER MEDICAL, FINANCIAL,
            LEGAL OR OTHERWISE. YOUR USE OF THE SITES, THE WIDGETS AND
            SERVICES IS AT YOUR SOLE RISK. THE SITE, THE WIDGETS AND SERVICES
            ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. MIOTECH MAKES
            NO REPRESENTATION OR WARRANTY THAT THE SITES, THE WIDGETS OR
            SERVICES WILL MEET YOUR REQUIREMENTS, OR WILL BE UNINTERRUPTED,
            SECURE, CURRENT OR ERROR-FREE, OR THAT THE RESULTS THAT MAY BE
            OBTAINED FROM THE USE OF THE SITES, THE WIDGETS, AND SERVICES WILL
            BE ACCURATE, TIMELY, USEFUL OR RELIABLE. TO THE GREATEST EXTENT
            PERMITTED BY LAW, MIOTECH DISCLAIMS ALL WARRANTIES,
            REPRESENTATIONS AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR
            IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES AND
            CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
            AND NON-INFRINGEMENT, WITH RESPECT TO THE USE OF THE WIDGETS THE
            SITE, AND ITS SERVICES, OR THE ACCURACY, COMPLETENESS, TIMELINESS
            OR CURRENTNESS OF ITS CONTENT, IN ANY WAY AND FOR ANY PURPOSE
          </strong>
          .
        </p>

        <p>
          <strong>
            EXCLUSION OF CONSEQUENTIAL DAMAGES: IN NO EVENT WILL MIOTECH BE
            LIABLE FOR ANY INCIDENTAL, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
            EXEMPLARY OR INDIRECT DAMAGES ARISING OUT OF THE USE OF OR
            INABILITY TO USE THE WIDGETS THIS WEBSITE OR ANY OF ITS SERVICES
            OR CONTENT, OR LOSS OF DATA, EVEN IF MIOTECH HAS BEEN ADVISED OF
            THE POSSIBILITY OF SUCH DAMAGES, AND WHETHER BASED ON CONTRACT,
            TORT, NEGLIGENCE, PRODUCT LIABILITY, STRICT LIABILITY OR
            OTHERWISE.
          </strong>
        </p>

        <p>
          <strong>
            Any material downloaded or otherwise obtained through the Sites or
            Services is done at each User's sole discretion and risk and each
            User is solely responsible for any damage to its own or to
            MioTech’s computer system(s) or any loss of data that may result
            from the download of any such material. No advice or information,
            whether oral or written, obtained by any User from MioTech or
            through or from the Sites shall create any warranty not expressly
            stated herein.
          </strong>
        </p>
        <p>
          <strong>
            The Sites may make available to User services or products provided
            by independent third parties. No warranty or representation is
            made with regard to such services or products. In no event shall
            MioTech or our affiliates be held liable for any such services or
            products.
          </strong>
        </p>
        <p>
          <strong>
            Each User hereby agrees to indemnify and save MioTech, our
            affiliates, directors, officers and employees harmless, from any
            and all losses, claims, liabilities (including legal costs on a
            full indemnity basis) which may arise from such User's access to
            or use of the Sites or Services (including but not limited to the
            display of such User's information on the Sites) or from your
            breach of any of the terms and conditions of the TOU. Each User
            hereby further agrees to indemnify and save MioTech, our
            affiliates, directors, officers and employees harmless, from any
            and all losses, damages, claims, liabilities (including legal
            costs on a full indemnity basis) which may arise from User's
            breach of any representations and warranties made by User to
            MioTech.
          </strong>
        </p>
        <p>
          <strong>
            Notwithstanding any of the foregoing provisions, the aggregate
            liability of MioTech, our employees, agents, affiliates,
            representatives or anyone acting on our behalf with respect to
            each User for all claims arising from the access to or use of the
            Sites or Services during any calendar year shall be limited to the
            lessor of (a) the amount of fees the User has paid to MioTech in
            exchange for the access to or use of the Sites or Services during
            the calendar year and (b) the maximum amount permitted under the
            applicable law. The preceding sentence shall not preclude the
            requirement by the User to prove actual damages. All claims
            arising from the use of the Sites or Services must be filed within
            one (1) year from the date the cause of action arose or such
            longer period as prescribed under the applicable law governing the
            Terms.
          </strong>
        </p>
        <p>
          <strong>
            The limitations and exclusions of liability to you under the TOU
            shall apply to the maximum extent permitted by law and shall apply
            whether or not MioTech has been advised of or should have been
            aware of the possibility of any such losses arising.
          </strong>
        </p>

        <h3>General</h3>

        <p>
          This TOU, and any applicable TOS, constitute the entire agreement
          between each User and MioTech governing the User's access to and use
          of the Sites and its Services, and supersede all prior agreements
          regarding its subject matter.
        </p>

        <p>
          The TOU shall be construed in accordance with and governed by the
          laws of the People’s Republic of China.
        </p>

        <p>
          Any dispute, controversy or claim arising out of or relating to this
          TOU, including any question regarding its existence, validity,
          interpretation or termination (a "Dispute") shall be settled through
          friendly consultations among the parties. If no settlement is
          reached within thirty (30) days from the date one party notifies
          another party or parties in writing that a Dispute has arisen, such
          Dispute shall then be referred to and finally resolved by Shanghai
          International Economic and Trade Arbitration Commission ("SHIAC")
          for arbitration, which shall be conducted in accordance with the
          SHIAC’s arbitration rules in effect at the time of applying for
          arbitration. There shall be a single arbitrator. Arbitrators may be
          appointed outside of the SHIAC panel of arbitrators. If the Parties
          do not agree to appoint an arbitrator who has consented to
          participate within twenty (20) days after the issuance of a notice
          of arbitration by any Party, SHIAC shall appoint an arbitrator.
          Arbitration proceedings shall be in Chinese and shall take place in
          Shanghai, the PRC. The arbitral award is final and binding upon the
          Parties
        </p>

        <p>
          The failure by a User or MioTech to exercise any right or to enforce
          any provision of this TOU shall not constitute a waiver of such
          right or provision. If any provision of this TOU is found by a court
          of competent jurisdiction to be invalid or unenforceable, the court
          shall give effect to the intentions reflected in the provision to
          the degree possible, and the other provisions of this TOU will
          remain in full force and effect.
        </p>

        <p>
          If any provision of the TOU is held to be invalid or unenforceable,
          such provision shall be deleted and the remaining provisions shall
          remain valid and be enforced.
        </p>

        <p>
          Under no circumstances shall MioTech be held liable for any delay or
          failure or disruption of the content or the Services accessed or
          delivered through the Sites resulting directly or indirectly from
          acts of nature, forces or causes beyond our reasonable control,
          including without limitation, Internet failures, computer,
          telecommunications or any other equipment failures, electrical power
          failures, strikes, labor disputes, riots, insurrections, civil
          disturbances, shortages of labor or materials, fires, flood, storms,
          explosions, acts of God, war, governmental actions, orders of
          domestic or foreign courts or tribunals or non-performance of third
          parties.
        </p>

        <p>
          <strong>
            MioTech shall have the right to assign the TOU (including all of
            our rights, titles, benefits, interests, and obligations and
            duties in the Terms to any person or entity (including any
            affiliates of MioTech). You may not assign, in whole or part, the
            TOU to any person or entity without MioTech’s prior written
            consent.
          </strong>
        </p>
      </div>
    ),
    [],
  );

  const cnZhContent = useMemo(
    () => (
      <div className="policy-content">
        <h2>使用条款</h2>
        <div style={{ marginBottom: 24 }}>
          <i>更新于2021年2月</i>
        </div>
        <p>
          欢迎访问妙盈科技运营的
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.miotech.com"
            style={{ margin: '0 4px' }}
          >
            www.MioTech.com
          </a>
          网站及其他妙盈科技网址和网站（统称“<strong>网站</strong>”）。
          您要访问和使用网站则需要接受本使用条款（“<strong>使用条款</strong>
          ”）。本使用条款规定了您访问和使用网站及我们通过网站提供的任何服务（统称为“
          <strong>服务</strong>”）的相关条款。
          <strong>
            请仔细阅读这些条款，如果您对使用条款有任何异议，请勿使用网站及任何服务。
          </strong>
          妙盈科技保留随时在网站上发布对使用条款进行变更的权利。如果我们对本使用条款进行了任何重大修订，我们将在本页发布变更后的使用条款及其生效日期，并通过电子邮件或在我们网站上发布通知告知您。
          <strong>
            如果您拒绝接受使用条款的任何变更，请务必停止使用网站。
          </strong>
          在使用条款中，“<strong>MioTech（妙盈科技）</strong>”和“
          <strong>我们</strong>”是指Mioying Financial
          Technology（HK）Limited和颖投信息科技（上海）有限公司及其关联公司，而“
          <strong>用户</strong>”和“<strong>您</strong>”指网站的每位访客。
        </p>

        <p>
          如果您订购网站提供的任何服务，可能还需要遵守此类服务适用的其他条款和条件（“
          <strong>服务条款</strong>”或“<strong>TOS</strong>
          ”），我们将在您使用时告知您该等条款和条件。
        </p>

        <h3>网站和服务</h3>

        <p>
          您须在网站上注册为会员才能获取和使用某些服务。此外，妙盈科技保留在未事先通知的情况下，限制付费用户获取或使用某些服务（或服务的任何功能），或设置其他妙盈科技自行决定的限制条件的权利。
        </p>

        <p>
          <strong>
            我们不能保证访问或使用网站或服务时不会出现中断或错误，而对于网站和服务的任何功能无法访问或无法使用的情形，妙盈科技不承担任何责任。
          </strong>
          为满足用户需要或因技术或其他原因，妙盈科技可在不事先通知或说明原因的情况下随时扩展、限制或修改网站及其功能。我们也可在不事先通知的情况下随时自行决定临时性或永久性停止提供任何或所有网站或服务。服务（或服务的功能）可能因国家地区而异。我们不保证或声明所有用户都能取得某项服务或服务的某项功能特性，或取得的服务或其功能特性的类型和范围相同。妙盈科技可自行决定限制或拒绝不同用户获取和使用的服务（或服务功能），或为不同用户创设不同的服务（或服务功能）获取和使用级别。
        </p>

        <p>
          为获取网站或其服务的某些内容或功能，用户可能需要升级或更新其计算机系统中的硬件或软件。若因用户系统、互联网或其他原因造成网站或服务部分或全部无法访问，妙盈科技不承担任何责任。
        </p>

        <h3>未成年人</h3>

        <p>
          我们不向未满13周岁的未成年人提供服务，也不会有意收集未满13周岁未成年人的个人身份信息。
          <strong>未满13周岁的未成年人不可使用网站。</strong>
          如我们发现收到了未满13周岁未成年人提供的个人信息，将立即将其从服务器删除。如果您为未成年人的父母或监护人，且知悉其向我们提供了个人资料，请联系我们，以便我们能够采取必要的措施。
        </p>

        <h3>遵守法律</h3>

        <p>
          您同意在购买和/或查看网站或服务的任何内容时遵守所有适用法律。另外，我们的网站或服务禁止对某些地区的用户开放。您同意，购买和/或查看网站或服务的任何内容时，不会违反适用的数据导出法律。
        </p>

        <h3>非个人投资建议</h3>

        <p>
          <strong>
            网站不提供个人或个性化的法律、税务、会计或投资服务。由于每个人的情况不同，因此在进行财务决策前应咨询具备资质的专业人士。
          </strong>
        </p>

        <h3>网站内容和服务限制</h3>

        <p>
          <strong>
            我们不保证网站或服务中提供的信息的准确性、完整性或优质性，仅按“原样”提供“可用”信息，风险由用户自行承担。该信息可能由第三方提供，若网站内容存在任何错误、遗漏或不实之处，妙盈科技概不负责。网站上提供的信息和投资、会计或法律分析策略（如有）既不全面也并非对每个人都适用。有些信息仅与中国大陆和香港相关，可能不符合其他国家的法律、法规或其他法律要求或与之无关。如果您想要使用这些信息，则您有责任确定此种使用是否在技术上和法律上在意图使用的地区可行，其可行性方案及范围。我们建议您在将任何信息用于个人、财务、会计、法律或商业用途前，先对该信息进行核实。另外，网站发布的及服务过程中发布的意见和观点不代表妙盈科技或其管理层的意见或建议。我们可能在不事先通知或说明原因的情况下随时修改网站的内容和服务，且妙盈科技没有义务通知您网站内容和服务的更正或变更。
          </strong>
        </p>

        <h3>使用网站内容和服务的许可</h3>

        <p>
          <strong>
            我们仅许可您本人在限定范围内访问和使用本网站的内容和服务，前提是不得修改该内容并应完整保留全部所有权声明。您不得复制、发布、翻译、合并、出售、出租、分发内容或在其他网站上制作其衍生品，也不得将之作为任何教育、培训或参考资料。您不得对网站和服务中获取的任何内容进行封装成帧或利用封装成帧技术进行处理。
          </strong>
        </p>

        <h3>第三方内容</h3>

        <p>
          第三方在网站、通过网站或在服务中提供的任何推荐、意见、建议、产品或服务报价（“第三方内容”）（如有）仅为其各自供应商的报价，而非妙盈科技的报价，妙盈科技不保证该第三方内容的准确性、完整性、可靠性或有用性。用户有责任对第三方内容进行评估，因用户信赖或以其他方式使用第三方内容造成的任何损害或损失，妙盈科技不承担任何责任。
        </p>

        <h3>妙盈科技插件</h3>

        <p>
          妙盈科技可以自行决定按照本使用条款提供某些插件（“插件”）。您获取和使用任何插件（包括复制任何插件超链接代码），即表示同意受以下约束：
          • 您只能在自己拥有并运营的网站上显示插件；
          <br /> •
          您不得修改任何插件，包括但不限于不得更改任何代码、遮盖或禁用任何插件的任何元素、给妙盈科技的链接标记为“no
          follow”属性或类似机制；
          <br />•
          您同意不作任何有关妙盈科技或网站的（明示或暗示的）声明或保证；
          <br /> •
          您不得暗示与妙盈科技存在任何关联关系、赞助关系或得到了妙盈科技的认可；
          <br />
          •
          您不得将插件配置在任何包含非法、有害、淫秽、骚扰性、种族歧视、民族歧视或其他令人反感的内容的网站上，也不得将插件配置在任何侵犯妙盈科技知识产权或其他权利或违反任何适用法律的网站上；
          <br />
          •
          除根据本条款显示插件的有限许可外，本使用条款未授予您任何妙盈科技代码、内容、徽标或商标的权利。
          <br />•
          妙盈科技保留权利，随时终止或修改您显示插件的权限。我们将自行决定不定期更改这些插件，及停止返回插件的内容。
        </p>

        <h3>创建账户</h3>

        <p>
          普通账户。妙盈科技提供的服务要求您创建帐户。创建帐户时，您同意您拥有创建该帐户的权限，且提供的所有信息均真实、准确、最新且完整。您应自行负责保留准确的登录信息（例如用户名和密码），并进行保密。您还应对使用您登录信息开展的所有活动负责。您同意在您怀疑您的登录信息被盗用时立即通知我们。因非授权使用您的登录信息造成的任何损失或损害，我们不承担任何责任。
          社交账号登录。如果您使用社交网络功能（例如Facebook）登录，则表示同意遵守社交网络的适用条款和条件。
        </p>

        <h3>高级服务—向用户提供</h3>

        <p>
          妙盈科技可能提供包括妙盈科技的AMI服务或其试用服务等服务（统称为“高级服务”）。用户通过这些服务可以使用妙盈科技的人工智能驱动投资技术进行风险管理。您使用和信赖此类服务（如有）应完全自担风险并自行负责始终遵守本使用条款。
        </p>

        <h3>重要提示：</h3>

        <p>
          <strong>
            非客户关系；无特权。妙盈科技提供高级服务无意也不会与网站的任何用户建立任何顾问客户关系、规划客户关系或任何其他直接特权或专业关系。此外，第三方内容均不视为私有或机密内容，也不受到律师-当事人或任何其他特权关系的保护，且妙盈科技和其他人均可浏览、收集和使用。
            <br />
          </strong>
          <br />
          <strong>
            请注意：妙盈科技不提供税务、会计、法律、投资或金融服务。妙盈科技在提供高级服务过程中提供的信息仅供参考，风险由用户自行承担。该信息不是也不应理解为投资、财务规划、法律、会计或税务方面的建议。妙盈科技发布任何信息或分析不是也不应视为妙盈科技对任何第三方的认可或推荐。妙盈科技不保证该信息的准确性、优质性或完整性，对信息的任何错误、遗漏或不实之处以及用户对其的依赖性，概不负责。用户应自行负责核实该信息是否适合其个人使用，包括但不限于就其可能遇到的具体财务、法律、会计或税务问题征求具备资质的专业人员的建议。妙盈科技未获得任何州/省/地区律师协会或其他法律或会计会员组织或协会、税务部门、机构或协会、美国金融业监管局（FINRA）、加拿大投资行业监管机构（IIROC），或任何其他金融监管部门、机构或协会的认可，也非其附属机构。
          </strong>
          <br />
          <br />
          未经妙盈科技的明确书面许可，您不得出于任何商业目的复制、上传、传输、分发、公开展示、出售、发布、复制、封装成帧或以封装成帧技术处理或以其他方式使用“高级服务”和/或其提供的任何内容或资料。
        </p>

        <h3>病毒</h3>
        <p>
          妙盈科技不保证从其网站下载的文件没有感染病毒或其他可能具有污染性或破坏性的代码。您自行负责运行必要的程序和动态检查点，满足您对数据输入和输出的完整性、安全性和准确性的具体要求，并保留网站外部用于恢复丢失数据的方法。
        </p>

        <h3>广告商未获得认可</h3>
        <p>
          虽然我们寻求与优质公司合作，但是我们对广告商和赞助商的主张或声明（如有）不承担任何责任。妙盈科技不会审查、认可或推荐我们网站上出现的任何公司的产品或服务。因广告商或赞助商滥用您提供的任何个人信息或资料造成的任何类型的损害，我们概不负责。
        </p>

        <h3>链接</h3>
        <p>
          为了方便客户，网站和服务可能提供跳转至其他网站或资源的链接。因为我们不审查也不控制此类网站和资源，所以如果您使用或依赖此类站点或资源的任何内容、产品、服务或信息，妙盈科技不承担任何责任。网站和服务包含此类链接并不表示妙盈科技认可或认同链接的网站、资源、其运营商或所有者，或与之存在关联、附属或赞助关系。您选择某个链接时，就可能会离开我们的网站。第三方网站信息在使用或分发方面的限制可能与本使用条款有所区别。
        </p>

        <h3>禁止行为</h3>
        <p>
          <strong>严禁从事以下活动：</strong>
          <br />• 出于非法或欺诈目的使用网站或服务（包括链接）；
          <br /> • 在网站上发布包含病毒或其他恶意或破坏性代码的资料；
          <br /> •
          从事任何具有诽谤性、侵犯他人个人隐私权或侵犯他人权利的活动；
          <br /> •
          将网站或服务用于非法、有害、威胁、侮辱、骚扰、侵权、诽谤、粗俗、淫秽、中伤、仇恨，贬低他人性别、种族、阶级、民族、国籍、宗教、性向、残疾等其他类型或其他负面的目的；
          <br />
          •
          对网站或服务进行复制、修改、逆向工程、反汇编等，或创作其衍生产品，或以其他方式试图找出网站或服务的任何源代码；
          <br />
          • 删除或遮盖通过站点或服务获取的内容上的版权声明或其他声明；
          <br /> •
          干扰或破坏网站的功能、服务或连接网站的服务器和网络，或者违背直接或间接连接网站的网络的任何要求、程序、政策或规定；
          <br />
          •
          为了（包括但不限于）越权访问网站或服务，以任何方式或形式修改网站或服务，或使用修改后的网站或服务；
          <br />
          •
          未经妙盈科技事先书面许可，以本使用条款未授权的方式或商业用途复制、打印、缓存、存储、封装成帧或分发网站或服务中检索的内容；
          <br />
          • 出售、转让、再许可或以其他方式移转服务或网站内容的任何权利；
          <br /> • 通过非妙盈科技提供的界面访问站点或服务；
          <br /> •
          使用网站或服务违反任何法律（无论地方、州/省/地区、国家法律还是国际法，无论是否有意）；
          <br />
          •
          冒充任何个人或实体，或虚假陈述或以其他方式歪曲您与任何个人或实体的关联关系；
          <br />
          • 从事“屏幕抓取”，“数据库抓取”；
          <br /> • 协助违反本使用条款或隐私政策的行为。
          <br />
          <br />
          <strong>
            如果任何用户违反了本使用条款的任何条款，或者妙盈科技有合理的理由认为用户违反了本使用条款的任何条款，包括任何用户从事了前述任何禁止活动，妙盈科技有权采取其认为适当的惩罚措施。此类惩罚措施包括但不限于：（i）妙盈科技可自行决定中止或终止用户的帐户及与该帐户有关的全部帐户，且对此造成的任何损失或损害，概不承担责任；（ii）限制、降级、中止或终止订阅、访问或（当前或今后）使用任何服务；（iii）对您使用任何服务的任何功能或特性施加妙盈科技自行认为合理的其他限制；及（v）妙盈科技自行认为必要或适当的任何其他纠正措施、惩罚或处罚。
          </strong>
        </p>

        <h3>隐私保护</h3>

        <p>
          网站可能会收集某些用户的个人信息。请查看我们的隐私政策，了解我们收集和存储的信息、如何使用该信息、如何共享该信息以及您享有的与个人信息相关的权利。隐私政策以提述方式纳入并构成本使用条款的组成部分。
        </p>

        <p>
          本隐私声明中，“公共领域数据”指通常在互联网上本来就公开的个人信息。如以下来源的个人信息：（i）证券交易所披露；（ii）执法机关、法院、监管机构或其他政府网站；（iii）知名的新闻媒体和出版物。
        </p>

        <h3>通信</h3>
        <p>
          您访问我们的网站、使用我们的任何服务或给我们发送电子邮件，即明确表示同意以电子方式接收我们就您使用网站和/或服务相关的全部信函、通知和我们披露的信息，包括但不限于电子邮件和站内信。我们通过电子邮件提供给您的所有协议、通知和通信满足以书面形式向您交付的所有法律要求。为了遵守法律程序或保护妙盈科技、其消费者、供应商和用户的权利或财产，妙盈科技有权披露用户发来的任何电子邮件或任何负面资料。根据适用法律的规定，通知中可能包含附带宣传推广、市场营销和广告信息以及我们认为您可能感兴趣的建议的电子邮件。您可以按照电子邮件的指示退订邮件，但我们仍然会向您发送管理和交易通知，包括但不限于您的帐户信息、您购买服务的确认函、进度信息，或为您提供任何服务必需的其他服务。
        </p>
        <p>
          如果您注册帐户或在网站上使用其他妙盈科技服务时向我们提供了电话号码，则表示您明确同意用该号码接收妙盈科技的自动拨号或预先录制电话和短信。如果该电话号码为手机号码，则您在此同意用该号码接收短信。我们会在以下情况下给您致电或发短信：（i）通知您帐户及使用情况；（ii）为您提供必要的服务等；（iii）解决您的帐户问题；（iv）解决争议；（v）联系您提供报价和促销；及（vi）为您的账户提供服务或执行本使用条款、我们的政策、适用法律或我们与您达成的任何其他协议所必要的其他情形。未经您同意，我们不会将您的电话号码告知第三方。我们可能会将您的电话号码分享给我们的关联方、服务提供商、计费或收款公司。他们与我们签订了合同，协助我们根据本使用条款、我们的政策、适用法律或我们与您订立的其他协议行使我们的权利或履行我们的义务。您同意，上述各方也可以使用自动拨号或预先录制的电话和短信联系您，以履行经我们授权的前述职责，而非实现个人目的。费用参考标准电话费和短信费。
        </p>
        <p>
          <strong>
            您理解并同意，为了质量控制、培训或自我保护，我们可以自行决定监控或记录您或您的代表与我们或我们的代理的电话交谈。您知悉并理解，虽然您与我们的通信可能会被监听、监控或记录，但不是所有电话线或电话都会被记录，且我们不保证会保留或能检索到任何具体电话的记录。
          </strong>
        </p>

        <h3>反馈</h3>
        <p>
          <strong>
            我们欢迎用户就我们的服务给出的所有反馈、意见、创意、素材和建议（统称“反馈”）。您理解并同意，妙盈科技不放弃使用其先前或同期已知的类似和/或相关反馈的任何权利，无论是由其员工、合同商开发，从其他来源获得还是由其他您提交的。
            此外，您提交反馈即授予我们无限制、无偿使用该反馈的权利。
          </strong>
        </p>

        <h3>所有权</h3>
        <p>
          妙盈科技网站及其内容受版权、商标和其他所有权法律的保护。
          <br />
          网站或服务中出现的所有妙盈科技徽标和/或商标都是我们的财产，未经我们明确书面同意不得使用。服务关联使用的所有其他商标、服务标志和徽标，无论是否署名，均为其各自所有者的商标、服务标志或徽标，未经其明确书面同意，不得使用。
          <br />
          版权侵权通知。妙盈科技认真对待版权侵权索赔。我们会根据适用法律应对涉嫌版权侵权的通知。
          <br />
          反复侵害者。如果您反复违反本使用条款，我们将根据政策在适当情况下禁止您访问网站和/或终止您的帐户。
          <br />
        </p>

        <h3>订阅服务</h3>
        <p>
          尽管妙盈科技向世界各地提供服务，但某些国家或地区可能无法获取或不适用某些妙盈科技的服务。我们保留在不事先通知的情况下随时中断或更改我们的网站和任何服务的权利。
        </p>

        <h3>责任限制</h3>
        <p>
          <strong>
            免责声明：网站和服务仅供参考之用。我们网站上的内容均不构成专业建议，无论是医疗、财务、法律还是其他方面。您使用网站、插件和服务须自行承担风险。该网站、插件、和服务均按“原样”提供并“可用”。妙盈科技不声明或保证其能满足您的需要，其安全、最新、准确无误且不会中断，或使用这些网站、插件和服务能获得准确、及时、有用或可靠的结果。在法律允许的最大范围内，妙盈科技拒绝以任何方式、出于任何目的就插件、网站和服务的使用或其内容的准确性、完整性、时效性或通用性提供任何明示或暗示的保证、声明或条件，包括但不限于适销性、具体适用性和非侵权性等方面的保证和条件。
          </strong>
        </p>

        <p>
          <strong>
            间接损害免责：在任何情况下，妙盈科技均不对因使用或无法使用插件、网站或其任何服务或内容，或资料丢失而导致的任何附带的，特别的，结果性的，惩罚性的或间接损害承担责任，即使妙盈科技已被告知此类损害的可能性，且无论是由于合同、侵权行为、疏忽大意、产品责任、严格责任还是其他原因。
          </strong>
        </p>

        <p>
          <strong>
            所有用户自行决定从网站或服务器下载或以其他方式获取任何资料并自担风险，并且对因下载此类资料给其自身或妙盈科技计算机系统造成任何损坏或任何资料丢失承担全部责任。用户从妙盈科技、网站或通过使用网站获得的任何口头或书面建议或资料均不构成本使用条款未明确说明的任何保证。
          </strong>
        </p>

        <p>
          <strong>
            本网站可能向用户提供第三方提供服务或产品，但不对此类服务或产品做任何保证或声明。妙盈科技及其关联方也不承担此类服务或产品的任何责任。
          </strong>
        </p>

        <p>
          <strong>
            所有用户在此同意对妙盈科技、我们的关联方、董事、高管和员工因用户访问或使用网站或服务（包括但不限于在网站上展示该用户的信息），或因用户违反本适用条款的任何条件和条款引起的所有损失、索赔、赔偿责任（包括全额赔偿法律成本）进行赔偿，使其免受损害。所有用户在此进一步同意对妙盈科技、我们的关联方、董事、高管和员工因用户违背对妙盈科技所做声明和保证访引起的所有损失、损害、索赔、赔偿责任（包括全额赔偿法律成本）进行赔偿，使其免受损害。
          </strong>
        </p>

        <p>
          <strong>
            尽管有任何前述规定，妙盈科技、我们的员工、代理商、关联方、代表或以我们的名义行事的任何人对于每位用户在任何日历年度因访问或使用网站或服务引起的全部索赔的累计赔偿责任不超过以下二者中的较小额：（a）用户在该年度向妙盈科技购买和使用网站或服务支付的费用金额；和（b）适用法律允许的最高金额。前一句未免除用户证明其实际损害的责任。因使用网站或服务引起的所有索赔须在诉讼事由产生之日起一（1）年内或本条款适用法律规定的较长期限内提出。
          </strong>
        </p>

        <p>
          <strong>
            根据使用条款，您应承担的责任范围和免责限度为法律允许的最大范围，且无论妙盈科技是否收到通知或知悉造成此类损失的可能性，均应适用。
          </strong>
        </p>

        <h3>一般条款</h3>
        <p>
          本使用条款及适用的服务条款构成用户与妙盈科技签订关于用户访问和使用站点及其服务的完整协议，并取代此前有关主题事宜的所有协议。
        </p>

        <p>本使用条款应遵照中华人民共和国法律进行解释并受其管辖。</p>

        <p>
          凡因本使用条款引起或与之相关的纠纷、争议或索赔，包括涉及其产生、效力、解释或终止（“争议”）的任何问题，各方应通过友好协商解决。如果自一方当事人就争议产生事宜书面通知另一方或多方当事人之日起三十（30）日之内未达成和解，该争议应提交上海国际经济贸易仲裁委员会（“
          SHIAC”）根据申请仲裁时有效的上海国际经济贸易仲裁委员会的仲裁规则进行仲裁并最终解决。仲裁庭由独任仲裁员组成，可以任命非上海国际经济贸易仲裁委员会仲裁员小组的仲裁员。如果当事人各方在一方当事人发出仲裁通知后二十（20）日内未就同意参与案件的仲裁员的任命达成一致意见，上海国际经济贸易仲裁委员会应指定一名仲裁员。仲裁程序应采用中文在中国上海进行。仲裁裁决为终局裁决，对双方均具有约束力。
        </p>

        <p>
          用户或妙盈科技未行使任何权利或执行本使用条款的任何条款不构成对该权利或条款的放弃。如果有管辖权的法院认为本使用条款的任何条款无效或不可执行，法院应在可能的范围内实行该条款反映的目的，且本使用条款的其他条款继续有效。
        </p>

        <p>
          如果本使用条款的任何条款无效或不可执行，则应删除该条款，而其他条款仍然有效并应得到执行。
        </p>

        <p>
          在任何情况下，因我们无法合理控制的不可抗力、武力或原因，包括但不限于互联网故障、计算机、电信或其他设备故障、电力故障、罢工、劳资纠纷、暴动、叛乱、内乱、劳动力或物资短缺、火灾、洪水、暴风雨、爆炸、天灾、战争、政府行为、国内或国外法院或法庭的命令，或第三方违约行为，直接或间接导致通过本网站访问或交付的内容或服务延迟、失败或中断，妙盈科技均不承担责任。
        </p>

        <p>
          <strong>
            妙盈科技有权将本使用条款（包括将条款规定的我们的所有权利、所有权、收益、利益及义务和责任）转让给任何个人或实体（包括妙盈科技的任何关联方）。未经妙盈科技事先书面同意，您不得将本使用条款全部或部分转让给任何人或实体。
          </strong>
        </p>
      </div>
    ),
    [],
  );

  const cnHkContent = useMemo(
    () => (
      <div className="policy-content">
        <h2>使用條款</h2>
        <div style={{ marginBottom: 24 }}>
          <i>更新於2021年2月</i>
        </div>
        <p>
          歡迎訪問妙盈科技運營的
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.miotech.com"
            style={{ margin: '0 4px' }}
          >
            www.MioTech.com
          </a>
          網站及其他妙盈科技網址和網站（統稱“<strong>網站</strong>”）。
          您要訪問和使用網站則需要接受本使用條款（“<strong>使用條款</strong>
          ”）。本使用條款規定了您訪問和使用網站及我們通過網站提供的任何服務（統稱為“
          <strong>服務</strong>”）的相關條款。
          <strong>
            請仔細閱讀這些條款，如果您對使用條款有任何異議，請勿使用網站及任何服務。
          </strong>
          妙盈科技保留隨時在網站上發布對使用條款進行變更的權利。如果我們對本使用條款進行了任何重大修訂，我們將在本頁發布變更後的使用條款及其生效日期，並通過電子郵件或在我們網站上發布通知告知您。
          <strong>
            如果您拒絕接受使用條款的任何變更，請務必停止使用網站。
          </strong>
          在使用條款中，“<strong>MioTech（妙盈科技）</strong>”和“
          <strong>我們</strong>”是指Mioying Financial
          Technology（HK）Limited和穎投信息科技（上海）有限公司及其關聯公司，而“
          <strong>用戶</strong>”和“<strong>您</strong>”指網站的每位訪客。
        </p>

        <p>
          如果您訂購網站提供的任何服務，可能還需要遵守此類服務適用的其他條款和條件（“
          <strong>服務條款</strong>”或“<strong>TOS</strong>
          ”），我們將在您使用時告知您該等條款和條件。
        </p>

        <h3>網站和服務</h3>

        <p>
          您須在網站上註冊為會員才能獲取和使用某些服務。此外，妙盈科技保留在未事先通知的情況下，限制付費用戶獲取或使用某些服務（或服務的任何功能），或設置其他妙盈科技自行決定的限制條件的權利。
        </p>

        <p>
          <strong>
            我們不能保證訪問或使用網站或服務時不會出現中斷或錯誤，而對於網站和服務的任何功能無法訪問或無法使用的情形，妙盈科技不承擔任何責任。
          </strong>
          為滿足用戶需要或因技術或其他原因，妙盈科技可在不事先通知或說明原因的情況下隨時擴展、限製或修改網站及其功能。我們也可在不事先通知的情況下隨時自行決定臨時性或永久性停止提供任何或所有網站或服務。服務（或服務的功能）可能因國家地區而異。我們不保證或聲明所有用戶都能取得某項服務或服務的某項功能特性，或取得的服務或其功能特性的類型和範圍相同。妙盈科技可自行決定限製或拒絕不同用戶獲取和使用的服務（或服務功能），或為不同用戶創設不同的服務（或服務功能）獲取和使用級別。
        </p>

        <p>
          為獲取網站或其服務的某些內容或功能，用戶可能需要升級或更新其計算機系統中的硬件或軟件。若因用戶系統、互聯網或其他原因造成網站或服務部分或全部無法訪問，妙盈科技不承擔任何責任。
        </p>

        <h3>未成年人</h3>

        <p>
          我們不向未滿13周歲的未成年人提供服務，也不會有意收集未滿13周歲未成年人的個人身份信息。
          <strong>未滿13周歲的未成年人不可使用網站。 </strong>
          如我們發現收到了未滿13周歲未成年人提供的個人信息，將立即將其從服務器刪除。如果您為未成年人的父母或監護人，且知悉其向我們提供了個人資料，請聯繫我們，以便我們能夠採取必要的措施。
        </p>

        <h3>遵守法律</h3>

        <p>
          您同意在購買和/或查看網站或服務的任何內容時遵守所有適用法律。另外，我們的網站或服務禁止對某些地區的用戶開放。您同意，購買和/或查看網站或服務的任何內容時，不會違反適用的數據導出法律。
        </p>

        <h3>非個人投資建議</h3>

        <p>
          <strong>
            網站不提供個人或個性化的法律、稅務、會計或投資服務。由於每個人的情況不同，因此在進行財務決策前應諮詢具備資質的專業人士。
          </strong>
        </p>

        <h3>網站內容和服務限制</h3>

        <p>
          <strong>
            我們不保證網站或服務中提供的信息的準確性、完整性或優質性，僅按“原樣”提供“可用”信息，風險由用戶自行承擔。該信息可能由第三方提供，若網站內容存在任何錯誤、遺漏或不實之處，妙盈科技概不負責。網站上提供的信息和投資、會計或法律分析策略（如有）既不全面也並非對每個人都適用。有些信息僅與中國大陸和香港相關，可能不符合其他國家的法律、法規或其他法律要求或與之無關。如果您想要使用這些信息，則您有責任確定此種使用是否在技術上和法律上在意圖使用的地區可行，其可行性方案及範圍。我們建議您在將任何信息用於個人、財務、會計、法律或商業用途前，先對該信息進行核實。另外，網站發布的及服務過程中發布的意見和觀點不代表妙盈科技或其管理層的意見或建議。我們可能在不事先通知或說明原因的情況下隨時修改網站的內容和服務，且妙盈科技沒有義務通知您網站內容和服務的更正或變更。
          </strong>
        </p>

        <h3>使用網站內容和服務的許可</h3>

        <p>
          <strong>
            我們僅許可您本人在限定範圍內訪問和使用本網站的內容和服務，前提是不得修改該內容並應完整保留全部所有權聲明。您不得複制、發布、翻譯、合併、出售、出租、分發內容或在其他網站上製作其衍生品，也不得將之作為任何教育、培訓或參考資料。您不得對網站和服務中獲取的任何內容進行封裝成幀或利用封裝成幀技術進行處理。
          </strong>
        </p>
        <h3>第三方內容</h3>

        <p>
          第三方在網站、通過網站或在服務中提供的任何推薦、意見、建議、產品或服務報價（“第三方內容”）（如有）僅為其各自供應商的報價，而非妙盈科技的報價，妙盈科技不保證該第三方內容的準確性、完整性、可靠性或有用性。用戶有責任對第三方內容進行評估，因用戶信賴或以其他方式使用第三方內容造成的任何損害或損失，妙盈科技不承擔任何責任。
        </p>

        <h3>妙盈科技插件</h3>

        <p>
          妙盈科技可以自行決定按照本使用條款提供某些插件（“插件”）。您獲取和使用任何插件（包括複製任何插件超鏈接代碼），即表示同意受以下約束：
          • 您只能在自己擁有並運營的網站上顯示插件；
          <br /> •
          您不得修改任何插件，包括但不限於不得更改任何代碼、遮蓋或禁用任何插件的任何元素、給妙盈科技的鏈接標記為“no
          follow”屬性或類似機制；
          <br />•
          您同意不作任何有關妙盈科技或網站的（明示或暗示的）聲明或保證；
          <br /> •
          您不得暗示與妙盈科技存在任何關聯關係、贊助關係或得到了妙盈科技的認可；
          <br />
          •
          您不得將插件配置在任何包含非法、有害、淫穢、騷擾性、種族歧視、民族歧視或其他令人反感的內容的網站上，也不得將插件配置在任何侵犯妙盈科技知識產權或其他權利或違反任何適用法律的網站上；
          <br />
          •
          除根據本條款顯示插件的有限許可外，本使用條款未授予您任何妙盈科技代碼、內容、徽標或商標的權利。
          <br />•
          妙盈科技保留權利，隨時終止或修改您顯示插件的權限。我們將自行決定不定期更改這些插件，及停止返回插件的內容。
        </p>

        <h3>創建賬戶</h3>

        <p>
          普通賬戶。妙盈科技提供的服務要求您創建帳戶。創建帳戶時，您同意您擁有創建該帳戶的權限，且提供的所有信息均真實、準確、最新且完整。您應自行負責保留準確的登錄信息（例如用戶名和密碼），並進行保密。您還應對使用您登錄信息開展的所有活動負責。您同意在您懷疑您的登錄信息被盜用時立即通知我們。因非授權使用您的登錄信息造成的任何損失或損害，我們不承擔任何責任。
          社交賬號登錄。如果您使用社交網絡功能（例如Facebook）登錄，則表示同意遵守社交網絡的適用條款和條件。
        </p>

        <h3>高級服務—向用戶提供</h3>

        <p>
          妙盈科技可能提供包括妙盈科技的AMI服務或其試用服務等服務（統稱為“高級服務”）。用戶通過這些服務可以使用妙盈科技的人工智能驅動投資技術進行風險管理。您使用和信賴此類服務（如有）應完全自擔風險並自行負責始終遵守本使用條款。
        </p>

        <h3>重要提示：</h3>

        <p>
          <strong>
            非客戶關係；無特權。妙盈科技提供高級服務無意也不會與網站的任何用戶建立任何顧問客戶關係、規劃客戶關係或任何其他直接特權或專業關係。此外，第三方內容均不視為私有或機密內容，也不受到律師-當事人或任何其他特權關係的保護，且妙盈科技和其他人均可瀏覽、收集和使用。
            <br />
          </strong>
          <br />
          <strong>
            請注意：妙盈科技不提供稅務、會計、法律、投資或金融服務。妙盈科技在提供高級服務過程中提供的信息僅供參考，風險由用戶自行承擔。該信息不是也不應理解為投資、財務規劃、法律、會計或稅務方面的建議。妙盈科技發布任何信息或分析不是也不應視為妙盈科技對任何第三方的認可或推薦。妙盈科技不保證該信息的準確性、優質性或完整性，對信息的任何錯誤、遺漏或不實之處以及用戶對其的依賴性，概不負責。用戶應自行負責核實該信息是否適合其個人使用，包括但不限於就其可能遇到的具體財務、法律、會計或稅務問題徵求具備資質的專業人員的建議。妙盈科技未獲得任何州/省/地區律師協會或其他法律或會計會員組織或協會、稅務部門、機構或協會、美國金融業監管局（FINRA）、加拿大投資行業監管機構（IIROC），或任何其他金融監管部門、機構或協會的認可，也非其附屬機構。
          </strong>
          <br />
          <br />
          未經妙盈科技的明確書面許可，您不得出於任何商業目的複制、上傳、傳輸、分發、公開展示、出售、發布、複製、封裝成幀或以封裝成幀技術處理或以其他方式使用“高級服務”和/或其提供的任何內容或資料。
        </p>

        <h3>病毒</h3>
        <p>
          妙盈科技不保證從其網站下載的文件沒有感染病毒或其他可能具有污染性或破壞性的代碼。您自行負責運行必要的程序和動態檢查點，滿足您對數據輸入和輸出的完整性、安全性和準確性的具體要求，並保留網站外部用於恢復丟失數據的方法。
        </p>

        <h3>廣告商未獲得認可</h3>
        <p>
          雖然我們尋求與優質公司合作，但是我們對廣告商和讚助商的主張或聲明（如有）不承擔任何責任。妙盈科技不會審查、認可或推薦我們網站上出現的任何公司的產品或服務。因廣告商或贊助商濫用您提供的任何個人信息或資料造成的任何類型的損害，我們概不負責。
        </p>

        <h3>鏈接</h3>
        <p>
          為了方便客戶，網站和服務可能提供跳轉至其他網站或資源的鏈接。因為我們不審查也不控制此類網站和資源，所以如果您使用或依賴此類站點或資源的任何內容、產品、服務或信息，妙盈科技不承擔任何責任。網站和服務包含此類鏈接並不表示妙盈科技認可或認同鏈接的網站、資源、其運營商或所有者，或與之存在關聯、附屬或贊助關係。您選擇某個鏈接時，就可能會離開我們的網站。第三方網站信息在使用或分發方面的限制可能與本使用條款有所區別。
        </p>

        <h3>禁止行為</h3>
        <p>
          <strong>嚴禁從事以下活動：</strong>
          <br />• 出於非法或欺詐目的使用網站或服務（包括鏈接）；
          <br /> • 在網站上發布包含病毒或其他惡意或破壞性代碼的資料；
          <br /> •
          從事任何具有誹謗性、侵犯他人個人隱私權或侵犯他人權利的活動；
          <br /> •
          將網站或服務用於非法、有害、威脅、侮辱、騷擾、侵權、誹謗、粗俗、淫穢、中傷、仇恨，貶低他人性別、種族、階級、民族、國籍、宗教、性向、殘疾等其他類型或其他負面的目的；
          <br />
          •
          對網站或服務進行複制、修改、逆向工程、反彙編等，或創作其衍生產品，或以其他方式試圖找出網站或服務的任何源代碼；
          <br />
          • 刪除或遮蓋通過站點或服務獲取的內容上的版權聲明或其他聲明；
          <br /> •
          干擾或破壞網站的功能、服務或連接網站的服務器和網絡，或者違背直接或間接連接網站的網絡的任何要求、程序、政策或規定；
          <br />
          •
          為了（包括但不限於）越權訪問網站或服務，以任何方式或形式修改網站或服務，或使用修改後的網站或服務；
          <br />
          •
          未經妙盈科技事先書面許可，以本使用條款未授權的方式或商業用途複製、打印、緩存、存儲、封裝成幀或分發網站或服務中檢索的內容；
          <br />
          • 出售、轉讓、再許可或以其他方式移轉服務或網站內容的任何權利；
          <br /> • 通過非妙盈科技提供的界面訪問站點或服務；
          <br /> •
          使用網站或服務違反任何法律（無論地方、州/省/地區、國家法律還是國際法，無論是否有意）；
          <br />
          •
          冒充任何個人或實體，或虛假陳述或以其他方式歪曲您與任何個人或實體的關聯關係；
          <br />
          • 從事“屏幕抓取”，“數據庫抓取”；
          <br /> • 協助違反本使用條款或隱私政策的行為。
          <br />
          <br />
          <strong>
            如果任何用戶違反了本使用條款的任何條款，或者妙盈科技有合理的理由認為用戶違反了本使用條款的任何條款，包括任何用戶從事了前述任何禁止活動，妙盈科技有權採取其認為適當的懲罰措施。此類懲罰措施包括但不限於：（i）妙盈科技可自行決定中止或終止用戶的帳戶及與該帳戶有關的全部帳戶，且對此造成的任何損失或損害，概不承擔責任；（ii
            ）限制、降級、中止或終止訂閱、訪問或（當前或今後）使用任何服務；（iii）對您使用任何服務的任何功能或特性施加妙盈科技自行認為合理的其他限制；及（v）妙盈科技自行認為必要或適當的任何其他糾正措施、懲罰或處罰。
          </strong>
        </p>

        <h3>隱私保護</h3>

        <p>
          網站可能會收集某些用戶的個人信息。請查看我們的隱私政策，了解我們收集和存儲的信息、如何使用該信息、如何共享該信息以及您享有的與個人信息相關的權利。隱私政策以提述方式納入並構成本使用條款的組成部分。
        </p>

        <p>
          本隱私聲明中，“公共領域數據”指通常在互聯網上本來就公開的個人信息。如以下來源的個人信息：（i）證券交易所披露；（ii）執法機關、法院、監管機構或其他政府網站；（iii）知名的新聞媒體和出版物。
        </p>

        <h3>通信</h3>
        <p>
          您訪問我們的網站、使用我們的任何服務或給我們發送電子郵件，即明確表示同意以電子方式接收我們就您使用網站和/或服務相關的全部信函、通知和我們披露的信息，包括但不限於電子郵件和站內信。我們通過電子郵件提供給您的所有協議、通知和通信滿足以書面形式向您交付的所有法律要求。為了遵守法律程序或保護妙盈科技、其消費者、供應商和用戶的權利或財產，妙盈科技有權披露用戶發來的任何電子郵件或任何負面資料。根據適用法律的規定，通知中可能包含附帶宣傳推廣、市場營銷和廣告信息以及我們認為您可能感興趣的建議的電子郵件。您可以按照電子郵件的指示退訂郵件，但我們仍然會向您發送管理和交易通知，包括但不限於您的帳戶信息、您購買服務的確認函、進度信息，或為您提供任何服務必需的其他服務。
        </p>
        <p>
          如果您註冊帳戶或在網站上使用其他妙盈科技服務時向我們提供了電話號碼，則表示您明確同意用該號碼接收妙盈科技的自動撥號或預先錄製電話和短信。如果該電話號碼為手機號碼，則您在此同意用該號碼接收短信。我們會在以下情況下給您致電或發短信：（i）通知您帳戶及使用情況；（ii）為您提供必要的服務等；（iii）解決您的帳戶問題；（iv）解決爭議；（
          v）聯繫您提供報價和促銷；及（vi）為您的賬戶提供服務或執行本使用條款、我們的政策、適用法律或我們與您達成的任何其他協議所必要的其他情形。未經您同意，我們不會將您的電話號碼告知第三方。我們可能會將您的電話號碼分享給我們的關聯方、服務提供商、計費或收款公司。他們與我們簽訂了合同，協助我們根據本使用條款、我們的政策、適用法律或我們與您訂立的其他協議行使我們的權利或履行我們的義務。您同意，上述各方也可以使用自動撥號或預先錄製的電話和短信聯繫您，以履行經我們授權的前述職責，而非實現個人目的。費用參考標準電話費和短信費。
        </p>
        <p>
          <strong>
            您理解並同意，為了質量控制、培訓或自我保護，我們可以自行決定監控或記錄您或您的代表與我們或我們的代理的電話交談。您知悉並理解，雖然您與我們的通信可能會被監聽、監控或記錄，但不是所有電話線或電話都會被記錄，且我們不保證會保留或能檢索到任何具體電話的記錄。
          </strong>
        </p>

        <h3>反饋</h3>
        <p>
          <strong>
            我們歡迎用戶就我們的服務給出的所有反饋、意見、創意、素材和建議（統稱“反饋”）。您理解並同意，妙盈科技不放棄使用其先前或同期已知的類似和/或相關反饋的任何權利，無論是由其員工、合同商開發，從其他來源獲得還是由其他您提交的。
            此外，您提交反饋即授予我們無限制、無償使用該反饋的權利。
          </strong>
        </p>

        <h3>所有權</h3>
        <p>
          妙盈科技網站及其內容受版權、商標和其他所有權法律的保護。
          <br />
          網站或服務中出現的所有妙盈科技徽標和/或商標都是我們的財產，未經我們明確書面同意不得使用。服務關聯使用的所有其他商標、服務標誌和徽標，無論是否署名，均為其各自所有者的商標、服務標誌或徽標，未經其明確書面同意，不得使用。
          <br />
          版權侵權通知。妙盈科技認真對待版權侵權索賠。我們會根據適用法律應對涉嫌版權侵權的通知。
          <br />
          反复侵害者。如果您反复違反本使用條款，我們將根據政策在適當情況下禁止您訪問網站和/或終止您的帳戶。
          <br />
        </p>

        <h3>訂閱服務</h3>
        <p>
          儘管妙盈科技向世界各地提供服務，但某些國家或地區可能無法獲取或不適用某些妙盈科技的服務。我們保留在不事先通知的情況下隨時中斷或更改我們的網站和任何服務的權利。
        </p>

        <h3>責任限制</h3>
        <p>
          <strong>
            免責聲明：網站和服務僅供參考之用。我們網站上的內容均不構成專業建議，無論是醫療、財務、法律還是其他方面。您使用網站、插件和服務須自行承擔風險。該網站、插件、和服務均按“原樣”提供並“可用”。妙盈科技不聲明或保證其能滿足您的需要，其安全、最新、準確無誤且不會中斷，或使用這些網站、插件和服務能獲得準確、及時、有用或可靠的結果。在法律允許的最大範圍內，妙盈科技拒絕以任何方式、出於任何目的就插件、網站和服務的使用或其內容的準確性、完整性、時效性或通用性提供任何明示或暗示的保證、聲明或條件，包括但不限於適銷性、具體適用性和非侵權性等方面的保證和條件。
          </strong>
        </p>

        <p>
          <strong>
            間接損害免責：在任何情況下，妙盈科技均不對因使用或無法使用插件、網站或其任何服務或內容，或資料丟失而導致的任何附帶的，特別的，結果性的，懲罰性的或間接損害承擔責任，即使妙盈科技已被告知此類損害的可能性，且無論是由於合同、侵權行為、疏忽大意、產品責任、嚴格責任還是其他原因。
          </strong>
        </p>

        <p>
          <strong>
            所有用戶自行決定從網站或服務器下載或以其他方式獲取任何資料並自擔風險，並且對因下載此類資料給其自身或妙盈科技計算機系統造成任何損壞或任何資料丟失承擔全部責任。用戶從妙盈科技、網站或通過使用網站獲得的任何口頭或書面建議或資料均不構成本使用條款未明確說明的任何保證。
          </strong>
        </p>

        <p>
          <strong>
            本網站可能向用戶提供第三方提供服務或產品，但不對此類服務或產品做任何保證或聲明。妙盈科技及其關聯方也不承擔此類服務或產品的任何責任。
          </strong>
        </p>

        <p>
          <strong>
            所有用戶在此同意對妙盈科技、我們的關聯方、董事、高管和員工因用戶訪問或使用網站或服務（包括但不限於在網站上展示該用戶的信息），或因用戶違反本適用條款的任何條件和條款引起的所有損失、索賠、賠償責任（包括全額賠償法律成本）進行賠償，使其免受損害。所有用戶在此進一步同意對妙盈科技、我們的關聯方、董事、高管和員工因用戶違背對妙盈科技所做聲明和保證訪引起的所有損失、損害、索賠、賠償責任（包括全額賠償法律成本）進行賠償，使其免受損害。
          </strong>
        </p>

        <p>
          <strong>
            儘管有任何前述規定，妙盈科技、我們的員工、代理商、關聯方、代表或以我們的名義行事的任何人對於每位用戶在任何日曆年度因訪問或使用網站或服務引起的全部索賠的累計賠償責任不超過以下二者中的較小額：（a）用戶在該年度向妙盈科技購買和使用網站或服務支付的費用金額；和（b）適用法律允許的最高金額。前一句未免除用戶證明其實際損害的責任。因使用網站或服務引起的所有索賠須在訴訟事由產生之日起一（1）年內或本條款適用法律規定的較長期限內提出。
          </strong>
        </p>

        <p>
          <strong>
            根據使用條款，您應承擔的責任範圍和免責限度為法律允許的最大範圍，且無論妙盈科技是否收到通知或知悉造成此類損失的可能性，均應適用。
          </strong>
        </p>
        <h3>一般條款</h3>
        <p>
          本使用條款及適用的服務條款構成用戶與妙盈科技簽訂關於用戶訪問和使用站點及其服務的完整協議，並取代此前有關主題事宜的所有協議。
        </p>

        <p>本使用條款應遵照中華人民共和國法律進行解釋並受其管轄。 </p>

        <p>
          凡因本使用條款引起或與之相關的糾紛、爭議或索賠，包括涉及其產生、效力、解釋或終止（“爭議”）的任何問題，各方應通過友好協商解決。如果自一方當事人就爭議產生事宜書面通知另一方或多方當事人之日起三十（30）日之內未達成和解，該爭議應提交上海國際經濟貿易仲裁委員會（“
          SHIAC”）根據申請仲裁時有效的上海國際經濟貿易仲裁委員會的仲裁規則進行仲裁併最終解決。仲裁庭由獨任仲裁員組成，可以任命非上海國際經濟貿易仲裁委員會仲裁員小組的仲裁員。如果當事人各方在一方當事人發出仲裁通知後二十（20）日內未就同意參與案件的仲裁員的任命達成一致意見，上海國際經濟貿易仲裁委員會應指定一名仲裁員。仲裁程序應採用中文在中國上海進行。仲裁裁決為終局裁決，對雙方均具有約束力。
        </p>

        <p>
          用戶或妙盈科技未行使任何權利或執行本使用條款的任何條款不構成對該權利或條款的放棄。如果有管轄權的法院認為本使用條款的任何條款無效或不可執行，法院應在可能的範圍內實行該條款反映的目的，且本使用條款的其他條款繼續有效。
        </p>

        <p>
          如果本使用條款的任何條款無效或不可執行，則應刪除該條款，而其他條款仍然有效並應得到執行。
        </p>

        <p>
          在任何情況下，因我們無法合理控制的不可抗力、武力或原因，包括但不限於互聯網故障、計算機、電信或其他設備故障、電力故障、罷工、勞資糾紛、暴動、叛亂、內亂、勞動力或物資短缺、火災、洪水、暴風雨、爆炸、天災、戰爭、政府行為、國內或國外法院或法庭的命令，或第三方違約行為，直接或間接導致通過本網站訪問或交付的內容或服務延遲、失敗或中斷，妙盈科技均不承擔責任。
        </p>

        <p>
          <strong>
            妙盈科技有權將本使用條款（包括將條款規定的我們的所有權利、所有權、收益、利益及義務和責任）轉讓給任何個人或實體（包括妙盈科技的任何關聯方）。未經妙盈科技事先書面同意，您不得將本使用條款全部或部分轉讓給任何人或實體。
          </strong>
        </p>
      </div>
    ),
    [],
  );

  const showContent = useMemo(() => {
    if (getLocale().toLowerCase() === 'zh-cn') {
      return cnZhContent;
    }
    if (getLocale().toLowerCase() === 'zh-hk') {
      return cnHkContent;
    }
    return enContent;
  }, [cnHkContent, cnZhContent, enContent]);

  if (!visible) {
    return null;
  }

  return showContent;
}

export default Service;
